export enum OrderStatus {
    CREATED = 'created',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}